import { render, staticRenderFns } from "./audit-logs-details-dialog-layout.vue?vue&type=template&id=6936923a&"
import script from "./audit-logs-details-dialog-layout.vue?vue&type=script&lang=js&"
export * from "./audit-logs-details-dialog-layout.vue?vue&type=script&lang=js&"
import style0 from "./audit-logs-details-dialog-layout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports